export default function* classGenerator() {
    while (true) {
        yield 'col-lg-8'
        yield 'col-lg-4'
        yield 'col-lg-6'
        yield 'col-lg-6'
        yield 'col-lg-4'
        yield 'col-lg-8'
    }
}